var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"s-item over",on:{"click":_vm.chooseSelect}},[_c('span',{staticClass:"s-item-l"},[(_vm.icon)?_c('i',{staticClass:"icon",class:_vm.icon}):_vm._e(),_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")]),_vm._v(" "),(_vm.rLabel)?_c('span',{staticClass:"s-item-r"},[_vm._v(_vm._s(_vm.rLabel)+" ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e499c952","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reception/public/byOption.vue
// module id = null
// module chunks = 